<template>
	<div class="container">
		<div class="center">
			<h1 class="title">MEET-A-SIDE</h1>
			<img alt="logo" class="logo mb-5" src="~@img/misc/logo.png">		
			<div class="buttons">
				<app-button :to="teacherTo" class="mb-3">{{$t('mainMenu.create')}}</app-button>
				<app-button :to="adminTo" accent="secondary" class="mb-3">{{$t('mainMenu.admin')}}</app-button>
				<!-- <language-selector /> -->
			</div>
		</div>
	</div>
</template>

<script>
    import AppButton from '@/components/app-button';  
    import LanguageSelector from '@/components/language-selector';
    import {getStudentUrl, getTeacherUrl, getAdminUrl} from '@/utils/UrlUtil';
	import * as MutationTypes from '@/store/mutation-types';

    export default {
		components: {
			AppButton,
			LanguageSelector
		},
		computed: {
			studentTo() {
				return getStudentUrl('connect');
			},
			teacherTo() {
				return getTeacherUrl('index');
			},
			adminTo() {
				return getAdminUrl('login');
			}
		},
		mounted() {
			this.$store.commit(MutationTypes.SET_BACKGROUND_ACCENT, 'primary');
		}
	}
</script>

<style lang="less" scoped>
	@import "~@less/font-sizes.less";

	.center {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.title {
		font-size: @font-size-xxxxl;
	}

	.logo {
		height: 350px;
	}

	.buttons {
		display: flex;
		flex-direction: column;
	}
</style>
